<div id="header">
    <div class="left-container">
        <sag-ui-switch [(ngModel)]="isEditActive" [disabled]="isEditDisabled">{{
            'organisation.editMode' | translate
        }}</sag-ui-switch>
    </div>
    <div class="right-container">
        @if (!isDeactivated && isCascadingAllowed) {
            @if (windowWidth > 1920) {
                @if (isMailingActive) {
                    <sag-ui-button icon="email" (click)="openDialogCommunication()">
                        {{ 'organisation.communication' | translate }}
                    </sag-ui-button>
                }

                <sag-ui-button icon="settings" (click)="openDialogSettings()">
                    {{ 'organisation.settings' | translate }}
                </sag-ui-button>

                @if (isAdmin) {
                    <sag-ui-button icon="play" (click)="openReporting()">
                        {{ 'organisation.reporting.start' | translate }}
                    </sag-ui-button>

                    <sag-ui-button icon="undo" (click)="openUnPublish()">
                        {{ 'organisation.reporting.unpublish' | translate }}
                    </sag-ui-button>
                }
            } @else {
                @if (isMailingActive) {
                    <sag-ui-button
                        sag-ui-tooltip
                        icon="email"
                        [square]="true"
                        [tooltip]="'organisation.communication' | translate"
                        (click)="openDialogCommunication()"
                    />
                }

                <sag-ui-button
                    sag-ui-tooltip
                    icon="settings"
                    [square]="true"
                    [tooltip]="'organisation.settings' | translate"
                    (click)="openDialogSettings()"
                />

                @if (isAdmin) {
                    <sag-ui-button
                        sag-ui-tooltip
                        icon="play"
                        [square]="true"
                        [tooltip]="'organisation.reporting.start' | translate"
                        (click)="openReporting()"
                    />

                    <sag-ui-button
                        sag-ui-tooltip
                        icon="undo"
                        [square]="true"
                        [tooltip]="'organisation.reporting.unpublish' | translate"
                        (click)="openUnPublish()"
                    />
                }
            }
        }
    </div>
</div>
